import { render } from "./DailySales.vue?vue&type=template&id=e284edb0"
import script from "./DailySales.vue?vue&type=script&lang=js"
export * from "./DailySales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Dashboard/DailySales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e284edb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e284edb0', __exports__)) {
    api.reload('e284edb0', __exports__)
  }
  
  module.hot.accept("./DailySales.vue?vue&type=template&id=e284edb0", () => {
    api.rerender('e284edb0', render)
  })

}


export default __exports__